import {useMemo,useState,useEffect} from 'react'
import {useFilteredMetricProgressData} from './hooks'
import { Line } from 'react-chartjs-2'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useMetricProgressLogger} from './hooks'
import {dateToYMD} from '../../util/datetime'
import { useDebounceCallback } from '@react-hook/debounce'
import LocaleDate from '../LocaleDate/LocaleDate'
import DataInput from './DataInput'
import {secondsToTimeObj} from '../../util/datetime'
import {ellipsis} from '../../util/util'
import css from './Metrics.module.css'

/**
 * Essentially the same code as ProgressGraph.js
 * But printing has issues in conjuction with responsive:true
 * So this component is tuned to be print only
 */
const PrintableProgressGraph = ({id})=>{
	const data = useFilteredMetricProgressData(id)
	//console.log(data)
	const {stats} = data
	const labels = stats.map( d => d.date )
	const chartData = stats.map( d => ({y:d.value,x:d.date,notes:d.notes}) )
	const r = ~~(100 * Math.random() - 25)
	//memoize the colors
	const borderColor = useMemo(()=>`hsla(${213-r}, 100%, 60%,0.8)`,[])
	const backgroundColor = useMemo(()=>`hsla(${213-r}, 100%, 60%,0.4)`,[])


	if ( stats.length === 0 ) return null
	return (
		<div className={css.NoBreak}>
			<div style={{height:'180px',width:'100%',position:'relative'}}>
				<Line
					height={180}
					width={1000}
					options={{
						title:{
							display:true,
							text:data.assessment_name,
							fontColor:'#1f1f1f',
							fontSize:18
						},
						
						legend:{
							display:false
						},
						animation: {
							duration: 0
						},
						maintainAspectRatio:false,
						responsive:false,
						scales:{
							xAxes:[{
								ticks:{
									//create local date labels
									callback:(value)=>new Date(`${value}T00:00:00`).toLocaleString([],{ year: 'numeric',month: '2-digit',day: 'numeric',})
								}
							}],
							yAxes:[{
								scaleLabel:{
									display:data.unit!=='None',
									labelString:data.unit==='time'?'seconds':data.unit,
									fontSize:14
								}
							}]
						}
					}}
					data={
						{
							labels,
							datasets: [{
								lineTension: 0,
								label: data.assessment_name,
								backgroundColor,
								borderColor,
								data:chartData,
								pointRadius: ({dataIndex,dataset:{data}})=>{
									const {notes} = data[dataIndex]
									return (
										Boolean(notes)
										? 4
										: 3
									)
								},
								pointHoverRadius: ({dataIndex,dataset:{data}})=>{
									const {notes} = data[dataIndex]
									return (
										Boolean(notes)
										? 6
										: 5
									)
								},
								pointBackgroundColor: ({dataIndex,dataset:{data}})=>{
									const {notes} = data[dataIndex]
									return (
										Boolean(notes)
										? '#fff'
										: backgroundColor
									)
								},
								pointBorderColor: ({dataIndex,dataset:{data}})=>{
									const {notes} = data[dataIndex]
									return (
										Boolean(notes)
										? '#1f1f1f'
										: borderColor
									)
								}
							}]
						}
					}
				/>
			</div>
		</div>
	)
}

export default PrintableProgressGraph